import baseService from '../../../lib/service/ServiceBase';
import { getVal } from '../../../lib/utils/UtilsCommon';

const PREFIX: string = 'CHANNEL_';

export const INIT_CHANNEL_PAGE_DATA: string = PREFIX + 'INIT_CHANNEL_PAGE_DATA';
export const INIT_DISCOUNT_EXTENDPO: string = PREFIX + 'INIT_DISCOUNT_EXTENDPO';
export const CHANNEL_C_GROUPING_LIST: string = PREFIX + 'CHANNEL_C_GROUPING_LIST';

/**
 * 初始化
 */
export function initChannelPageData(pageData: any): any {
	return {
		type: INIT_CHANNEL_PAGE_DATA,
		pageData,
	};
}

/**
 * 更新特价信息
 */
export function updateDiscountExtendPo(discountExtendPo: any): any {
	return (dispatch: any, getStore: any): void => {
		dispatch({
			type: INIT_DISCOUNT_EXTENDPO,
			discountExtendPo,
		});
	};
}

/**
 * 更新拼团信息
 */
export function updateChannelGroupingList(channelId: string): any {
	return async (dispatch: any, getStore: any): Promise<any> => {
		const result: any = await baseService.commonApi({
			url: '/api/wechat/channel/getChannelGroupingList',
			body: {
				channelId,
			},
		});
		dispatch({
			type: CHANNEL_C_GROUPING_LIST,
			groupingList: getVal(result, 'data.groupList', []),
		});

		return result;
	};
}
